exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".widget_title{position:absolute;top:0;left:0;z-index:500;margin:20px 0 0 30px;font-size:24px;line-height:1em;height:26px;overflow:hidden}div.table{background:#fff;border-radius:3px}div.table .table-row{padding:85px 0 0;margin:0;height:100%;width:100%;display:table;border-radius:3px}.userImage{margin:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.avatar{border-radius:50%}.topscore-initials{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;line-height:24px;font-size:20px;font-weight:700;z-index:1;text-transform:uppercase;font-family:Roboto,sans-serif}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?outputStyle=expanded!./client/components/Widgets/CompetitionWidgets/CompetitionTopListWidget.scss
 ** module id = 771
 ** module chunks = 0
 **/